/**
 * @generated SignedSource<<ee651bfa957d0594595542c3dc4845c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SkillCategoryRow_skillCategory$data = {
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentType": "SkillCategoryRow_skillCategory";
};
export type SkillCategoryRow_skillCategory$key = {
  readonly " $data"?: SkillCategoryRow_skillCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"SkillCategoryRow_skillCategory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillCategoryRow_skillCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "SkillCategory",
  "abstractKey": null
};

(node as any).hash = "87ed52423512a020c8ee085652356932";

export default node;
